import React, { useEffect, useState } from "react";
import { Font, StyleSheet, Text, View } from "@react-pdf/renderer";
import ArabicComponent from "../../../../../../utils/ArabComponent/ArabicComponent";
import { getTermsTableArabicData, getTermsTableEnglishData } from "./Data";
import ArabicRegular from "../../../../../../assets/ArabicFont/IBMPlexSansArabic-Regular.ttf";
import ArabicBold from "../../../../../../assets/ArabicFont/IBMPlexSansArabic-Bold.ttf";

const Page2 = ({ contractDetails }) => {
  Font.register({
    family: "Arabic",
    src: ArabicRegular,
  });
  Font.register({
    family: "ArabicBold",
    src: ArabicBold,
  });
  const styles = StyleSheet.create({
    page: {
      backgroundColor: "white",
      paddingHorizontal: 20,
      // paddingVertical: 30,
      fontSize: 9,
      paddingBottom: 100,
    },
    divider: {
      width: 1, // Width of the divider
      backgroundColor: "#000", // Divider color
      height: "100%", // Full height of the row
    },
    arabic: {
      fontFamily: "Arabic",
      flexDirection: "row",
      textAlign: "right",
      writingMode: "horizontal-tb",
      direction: "rtl",
      fontSize: "9px",
    },
    tableContainer: {
      marginTop: 10,
    },
    tableHeaderLine: {
      borderTopWidth: 1,
      borderTopColor: "#000",
      marginBottom: 0,
    },
    tableRow: {
      flexDirection: "row",
      borderTopWidth: 1, // Line on top of the row
      borderBottomWidth: 1, // Line on bottom of the row
      borderColor: "#000",
      borderStyle: "solid",
    },
    tableCell: {
      flex: 1,
      padding: 8,
      fontSize: 10,
      borderRightWidth: 1, // Divider between cells
      borderColor: "#000",
    },
    firstCell: {
      borderLeftWidth: 1, // Divider on the left side of the first cell
      borderColor: "#000",
    },
    lastCell: {
      flex: 1,
      padding: 8,
      borderLeftWidth: 1, // Divider on the left side of the last cell
      borderRightWidth: 1, // Divider on the right side of the last cell
      borderColor: "#000",
    },
    tableHeader: {
      fontWeight: "bold",
      fontSize: 12,
      padding: 10,
      textAlign: "center",
      borderBottomWidth: 1,
      borderBottomColor: "#000",
    },
    nestedRow: {
      flexDirection: "row",
      paddingLeft: 16,
      borderTopWidth: 1,
      borderColor: "#ccc",
    },
  });
  const [termsArabic, setTermsArabic] = useState([]);
  const [termsEnglish, setTermsEnglish] = useState([]);

  useEffect(() => {
    if (contractDetails) {
      const _termsArabic = getTermsTableArabicData(contractDetails);
      const _termsEnglish = getTermsTableEnglishData(contractDetails);
      setTermsArabic(_termsArabic);
      setTermsEnglish(_termsEnglish);
    }
  }, [contractDetails]);

  return (
    <>
      <Text
        style={{
          marginTop: 15,
          fontFamily: "Helvetica-Bold",
          marginBottom: 20,
          marginRight: 4,
        }}
      >
        ll. TERMS:
        <ArabicComponent arabText={"الفقرة الثانية:"} />
      </Text>
      {/* table 3 */}
      <View style={{ width: "100%", height: 1, borderBottom: 1 }} fixed></View>
      {/* <View
        style={{
          flexDirection: "row",
          border: 1,
          borderTop: 0,
          borderBottom: 0,
        }}
      >
        
        <View
          style={{
            borderRight: 1,
            width: "100%",
            padding: 5,
            lineHeight: 1.5,
          }}
        >
          {termsEnglish?.map((item, index) => (
            <View
              style={{
                marginVertical: 10,
                height:
                  index <= 2
                    ? 50
                    : index > 2 && index <= 6
                    ? 100
                    : index >= 8 && index <= 10
                    ? 40
                    : index == 11
                    ? 180
                    : index == 12
                    ? 380
                    : index == 15
                    ? 140
                    : index == 14 && index == 13
                    ? 300
                    : index > 15
                    ? 100
                    : "",
              }}
              key={index}
            >
              <View style={{ flexDirection: "row", gap: 2, marginBottom: 3 }}>
                <Text style={{ fontSize: 9 }} break>
                  {index + 1}.
                </Text>
                <Text
                  style={{
                    textOverflow: "ellipsis",
                    width: "98%",
                    fontSize: 9,
                  }}
                  break
                >
                  {item?.text}
                </Text>
              </View>
              {item.sub.map((sub, subindex) => (
                <View
                  key={subindex}
                  style={{
                    flexDirection: "row",
                    alignItems: "center",
                    gap: 3,
                    marginVertical: 4,
                  }}
                >
                  <Text style={{ fontSize: 15 }} break>
                    &#8226;
                  </Text>
                  <Text style={{ fontSize: 9, width: "98%" }} break>
                    {sub}
                  </Text>
                </View>
              ))}
            </View>
          ))}
        </View>
        <View
          style={{
            width: "100%",
            padding: 5,
            lineHeight: 1.5,
            marginTop: "10px",
          }}
        >
          {termsArabic?.map((item, index) => (
            <View
              style={{
                width: "100%",
                marginVertical: 10,
                height:
                  index <= 2
                    ? 50
                    : index > 2 && index <= 6
                    ? 100
                    : index == 7
                    ? 140
                    : index >= 8 && index <= 10
                    ? 40
                    : index == 11
                    ? 180
                    : index == 12
                    ? 380
                    : index == 13
                    ? 170
                    : index == 14
                    ? 165
                    : index == 15
                    ? 140
                    : index > 15 && index <= 16
                    ? 100
                    : index == 17
                    ? 80
                    : index > 17 && index <= 21
                    ? 100
                    : index == 22 ? 150 : index > 22 ? 100 : "",
              }}
              key={index}
            >
              <View
                style={{
                  display: "flex",
                  flexDirection: "row",
                  marginVertical: 10,
                }}
              >
                <ArabicComponent
                  arabText={item.text}
                  componentStyle={{
                    width: "98%",
                  }}
                  textStyle={{
                    textOverflow: "ellipsis",
                    fontSize: 9,
                  }}
                  textBreak={true}
                />
                <Text style={{ fontSize: 9 }} break>
                  .{index + 1}
                </Text>
              </View>
              {item.sub.map((sub, subindex) => (
                <View
                  key={subindex}
                  style={{
                    display: "flex",
                    width: "100%",
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                    fontFamily: "Arabic",
                    gap: 3,
                    marginVertical: 3,
                  }}
                >
                  <ArabicComponent
                    arabText={sub}
                    textBreak={true}
                    textStyle={{
                      fontSize: 9,
                    }}
                  />
                  <Text style={{ fontSize: 15, paddingRight: "10px" }} break>
                    &#8226;
                  </Text>
                </View>
              ))}
            </View>
          ))}
        </View>
      </View> */}
      {termsEnglish?.map((data, index) => (
        <>
          <View
            style={{
              flexDirection: "row",
              borderTop: 0.5,
              borderBottom: 0.5,
              borderLeft: 1,
              borderRight: 1,
            }}
            key={index}
          >
            <View style={{ width: "50%", borderRight: 1, padding: 10 }}>
              <Text break>{data.text}</Text>
              {data.sub.map((subItem, subIndex) => (
                <Text key={subIndex} break>
                  . {subItem}
                </Text>
              ))}
            </View>
            <View style={{ width: "50%", borderRight: 1, padding: 10 }}>
              <Text break style={[styles.arabic]}>
                {termsArabic[index].text}
              </Text>
              {termsArabic[index].sub.map((subItem, subIndex) => (
                <Text key={subIndex} break style={[styles.arabic]}>
                  . {subItem}
                </Text>
              ))}
            </View>
          </View>
        </>
      ))}
      <View style={{ width: "100%", height: 1, borderTop: 1 }} fixed></View>
    </>
  );
};

export default Page2;
